"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalQuestionsWidget = void 0;
var React = require("react");
var commonFunctions_1 = require("../../../commonFunctions");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var services_1 = require("@falcon/services");
var AdditionalQuestionsWidget = /** @class */ (function (_super) {
    __extends(AdditionalQuestionsWidget, _super);
    function AdditionalQuestionsWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        return _this;
    }
    AdditionalQuestionsWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderAdditionalQuestions()));
    };
    AdditionalQuestionsWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("mileage");
    };
    AdditionalQuestionsWidget.prototype.renderAdditionalQuestions = function () {
        var _this = this;
        // This is a dirty workaround, however to implement it in a normal way, either the FAL-6328 or FAL-5885 has to be done first
        var carIndex = this.props.interaction.process === services_1.INTERACTION_PROCESS_MTA ? 0 : this.vehicleIndex;
        var vehicle = this.props.interaction.vehicles[carIndex];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-center" },
                React.createElement("div", { className: "panel-detail-output-entity" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "muli-bold-16" }, "Date of purchase")),
                    React.createElement("div", null,
                        React.createElement("p", null, (0, commonFunctions_1.convertDate)(vehicle.purchaseDate, "MMM YYYY")))),
                React.createElement("div", { className: "panel-detail-output-entity" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "muli-bold-16" }, "Annual mileage")),
                    React.createElement("div", null,
                        React.createElement("p", null, this.resolveLookupValue("mileage", vehicle.mileage.toString())))),
                React.createElement("div", { className: "panel-detail-output-entity" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "muli-bold-16" }, "Overnight post code")),
                    React.createElement("div", null,
                        React.createElement("p", null, vehicle.overnightLocationIsHome ? this.props.interaction.policyHolder.address.postcode : vehicle.overnightLocationPostcode))),
                React.createElement("div", { className: "panel-detail-output-entity" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "muli-bold-16" }, "Registered keeper")),
                    React.createElement("div", null,
                        React.createElement("p", null, (0, commonFunctions_1.getRegisteredKeeper)(this.props.interaction, carIndex)))),
                React.createElement("div", { className: "form-group pt-2" },
                    React.createElement("button", { type: "button", onClick: function () { return _this.editAnswers(); }, className: "btn btn-white-dashboard m-auto" }, "Edit answers")))));
    };
    AdditionalQuestionsWidget.prototype.editAnswers = function () {
        var navigateToPage = this.getSetting("navigateToPage", undefined);
        if (navigateToPage) {
            this.props.engine.navigate(navigateToPage, false);
        }
        else {
            this.props.engine.navigate("editVehicle".concat(this.vehicleIndex, "AnswersPage"), false);
        }
    };
    return AdditionalQuestionsWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
exports.AdditionalQuestionsWidget = AdditionalQuestionsWidget;
//# sourceMappingURL=AdditionalQuestionsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/AdditionalQuestionsWidget.js
// module id = 3161
// module chunks = 0